import "./NavBar.css";
import { Link } from "react-router-dom";
import { MdLogout } from "react-icons/md";
import { BiMessageAltDetail} from "react-icons/bi";
import { MdTravelExplore } from "react-icons/md";
import { RiHomeSmileFill, RiUserAddLine } from 'react-icons/ri'
import { MdSettings } from 'react-icons/md'
import { useContext } from "react";
import AuthContext from "../context/AuthProvider";

export default function NavBar() {
  const { authState, setAuthState } = useContext(AuthContext)
  // console.log('from nav',authState);
  const user = authState.user

  const logout = ()=>{
  //   try {
  //     axios.post(`/auth/logout`,{token: authState.accessToken}, {headers: {authorization: 'Bearer '+user.accessToken}})
  // } catch (error) {
  //     console.log('You need rtoken');
  // }
    setAuthState({})
    localStorage.clear();
  }
  
  return (
    <nav className="navbar">
      <Link to={`/profile/${user}`}>
        <div className="navbar__logo">
          <span className="logo">DevHub</span>
        </div>
      </Link>
      <div className="navbar__items">
      <div className="navbar__item-ctr">
          <Link className="navbar__item" to="/">
            <RiHomeSmileFill />
          </Link>
        </div>
        <div className="navbar__item-ctr">
          <Link className="navbar__item" to="/explore">
            <MdTravelExplore />
          </Link>
        </div>
        <div className="navbar__item-ctr">
          <Link className="navbar__item" to="/users">
            <RiUserAddLine />
          </Link>
        </div>
        <div className="navbar__item-ctr">
          <Link className="navbar__item" to="/message">
            <BiMessageAltDetail />
          </Link>
        </div>
        <div className="navbar__item-ctr">
          <Link className="navbar__item" style={{fontSize: "3.32rem"}} to="/settings">
            <MdSettings />
          </Link>
        </div>
        <div className="navbar__item-ctr">
          <div className="navbar__item" style={{fontSize: "3.32rem", cursor: 'pointer'}} onClick={logout}>
            <MdLogout />
          </div>
        </div>
      </div>
      <div className="navbar__profile">
        <Link to={`/profile/${user}`} state={{searchUsrId: user.id}}>
        <div className="user-profile">
          {/* <img className="user-profile__img" src={pf_CONTENT+user.avatar} alt="profile" /> */}
          {/* <img className="user-profile__img" src={user.avatar?user.avatar:'./1.jpg'} alt="profile" /> */}
          <img className="user-profile__img" src={authState.avatar?authState.avatar:'assets/person/4.jpg'} alt="profile" />
        </div>
        </Link>
        <h2>{user.username}</h2>
        <span>{user.skill}</span>
      </div>
    </nav>
  );
}
